import { FakDokumentSum } from './faktura/fak-dokument-sum.component';
import { FakDokumentStavkaInlineUpdateComponent } from './faktura/fak-dokument-stavka-inline-update.component';
import { FakDokumentStavkaUpdateContainer } from './faktura/fak-dokument-stavka-update-container.component';
import { FakDokumentUpdateComponent } from './faktura/fak-dokument-update.component';
import { FakDokumentStavkaModalUpdateComponent } from './faktura/fak-dokument-stavka-modal-update.component';
import { FakDokumentStavkaUpdateComponent } from './faktura/fak-dokument-stavka-update.component';
import { FakDokumentTabUpdateComponent } from './faktura/fak-dokument-tab-update.component';
import { FakDokumentTabsComponent } from './faktura/fak-dokument-tabs.component';
import { ModalContainerService, ModalService } from 'yt-ng-framework';
import { FakComponent } from './fak.component';
import { VrstaStavkiModalUpdateComponent } from './vrsta-stavki/vrsta-stavki-modal-update.component';
import { FakRoutingModule } from './fak-routing.module';
import { HomeComponent } from './home/home.component';
import { LookupsModule } from './../lookups/lookups.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { NgModule } from "@angular/core";
import { VrstaStavkiComponent } from './vrsta-stavki/vrsta-stavki.component';
import { VrstaStavkiUpdateComponent } from './vrsta-stavki/vrsta-stavki-update.component';
import { FakVrstaTroskaComponent } from './fak-vrsta-troska/fak-vrsta-troska.component';
import { FakVrstaTroskaModalUpdateComponent } from './fak-vrsta-troska/fak-vrsta-troska-modal-update.component';
import { FakVrstaTroskaUpdateComponent } from './fak-vrsta-troska/fak-vrsta-troska-update.component';
import { TrosakDokumentTabsComponent } from './trosak/trosak-dokument-tabs.component';
import { TrosakDokumentTabUpdateComponent } from './trosak/trosak-dokument-tab-update.component';
import { TrosakDokumentUpdateComponent } from './trosak/trosak-dokument-update.component';
import { TrosakDokumentStavkaUpdateComponent } from './trosak/trosak-dokument-stavka-update.component';
import { TrosakDokumentStavkaUpdateContainerComponent } from './trosak/trosak-dokument-stavka-update-container.component';
import { TrosakDokumentStavkaModalUpdateComponent } from './trosak/trosak-dokument-stavka-modal-update.component';
import { TrosakDokumentStavkaInlineUpdateComponent } from './trosak/trosak-dokument-stavka-inline-update.component';
import { TrosakDokumentSumComponent } from './trosak/trosak-dokument-sum.component';
import { RekapitulacijaTroskovaComponent } from './_reports/rekapitulacija-troskova/rekapitulacija-troskova.component';
import { FilterWithKomitentComponent } from './_filters/filter-with-komitent.component';
import { DefaultFilter } from './../lookups/default-filter/default-filter.component';
import { OdabirAvansaComponent } from './faktura/odabir/odabir-avansa.component';
import { OdabirDokumentaComponent } from './faktura/odabir/odabir-dokumenta.component';
import { RekapitulacijaDokumenataComponent } from './_reports/rekapitulacija_dokumenata/rekapitulacija-dokumenata.component';
import { OdabirDokumentaV2Component } from './faktura/odabir/odabir-dokumenta-v2.component';
import { RekapitulacijaRacunaComponent } from './_reports/rekapitulacija_racuna/rekapitulacija-racuna.component';
import { FilterWithPovezanDokumentComponent } from './_filters/filter-with-povezan-dokument.component';
import { SpisakIskoriscenihComponent } from './faktura/odabir/spisak-iskoriscenih.component';
import { SpisakPoreskihOslobodjenjaComponent } from './faktura/spisak-poreskih-oslobodjenja/spisak-poreskih-oslobodjenja.component';
import { RekapitulacijaComponent } from './_reports/rekapitulacija/rekapitulacija.component';
import { VrstaDatumaPoreskeObavezeComponent } from './vrsta-datuma-poreske-obaveze/vrsta-datuma-poreske-obaveze.component';
import { SendEdokumentComponent } from './faktura/edokument/send-edokument.component';
import { FilterWithOrgJedComponent } from './_filters/filter-with-org-jed.component';
import { EkranskaKarticaKomitenataComponent } from './_reports/ekranska-kartica-komitenata/ekranska-kartica-komitenata.component';
import { VrstaStavkiKodKupcaComponent } from './vrsta-stavki-kod-kupca/vrsta-stavki-kod-kupca.component';
import { VrstaStavkiKodKupcaUpdateComponent } from './vrsta-stavki-kod-kupca/vrsta-stavki-kod-kupca-update.component';
import { VrstaStavkiKodKupcaModalUpdateComponent } from './vrsta-stavki-kod-kupca/vrsta-stavki-kod-kupca-modal-update.component';
import { FilterOnlyKomitentComponent } from './_filters/filter-only-komitent.component';
import { EkranskaKarticaKomitenataModalComponent } from './_reports/ekranska-kartica-komitenata/ekranska-kartica-komitenata-modal.component';
import { EkranskaKarticaKomitenataUpdateComponent } from './_reports/ekranska-kartica-komitenata/ekranska-kartica-komitenata-update.component';
import { PoljaZaVelikeLanceComponent } from './faktura/polja-za-velike-lance/polja-za-velike-lance.component';
import { OdabirAvansaV2Component } from './faktura/odabir/odabir-avansa-v2.component';
import { DefaultTableWithExpandComponent } from './faktura/odabir/default-table-with-expand/default-table-with-expand.component';
import { GetPropertyValuePipe } from './faktura/odabir/default-table-with-expand/get-property-value.pipe';
import { RowColorDirective } from './faktura/odabir/default-table-with-expand/row-color.directive';
import { GabaritiRobeComponent } from './faktura/gabariti-robe/gabariti-robe.component';
// import { SimpleNotificationsModule } from 'angular2-notifications';
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TransporteriComponent } from './faktura/transporteri/transporteri.component';
import { FakDokumentService } from './faktura/fak-dokument-service';
import { IzvestajONenaplacenimRacunimaComponent } from './_reports/izvestaj-o-nenaplacenim-racunima/izvestaj-o-nenaplacenim-racunima.component';
import { InstrukcijeZaPlacanjaComponent } from './faktura/odabir/instrukcije-za-placanja.component';
import { FakDokumentUplataUpdateComponent } from './faktura/fak-dokument-uplata/fak-dokument-uplata-update.component';
import { FakDokumentUplataModalUpdateComponent } from './faktura/fak-dokument-uplata/fak-dokument-uplata-modal-update.component';




import { PonoviComponent } from './_forme/ponovi/ponovi.component';
import { KpoObrazacComponent } from './_reports/kpo-obrazac/kpo-obrazac.component';



@NgModule({
    imports:[
        FakRoutingModule,
        LookupsModule,
        NgbModule,
        TranslateModule.forChild()
    ],
    declarations:[HomeComponent
        , FakComponent
        , VrstaStavkiComponent
        , VrstaDatumaPoreskeObavezeComponent
        , VrstaStavkiUpdateComponent
        , VrstaStavkiModalUpdateComponent
        , FakDokumentTabsComponent
        , FakDokumentTabUpdateComponent
        , FakDokumentStavkaUpdateComponent
        , FakDokumentStavkaModalUpdateComponent
        , FakDokumentUpdateComponent
        , FakDokumentStavkaUpdateContainer
        , FakDokumentStavkaInlineUpdateComponent  
        , FakDokumentSum
        , FakVrstaTroskaComponent, FakVrstaTroskaModalUpdateComponent, FakVrstaTroskaUpdateComponent
        , TrosakDokumentTabsComponent, TrosakDokumentTabUpdateComponent, TrosakDokumentUpdateComponent
        , TrosakDokumentStavkaUpdateComponent, TrosakDokumentStavkaUpdateContainerComponent, TrosakDokumentStavkaModalUpdateComponent
        , TrosakDokumentStavkaInlineUpdateComponent, TrosakDokumentSumComponent
        , RekapitulacijaTroskovaComponent
        , FilterWithKomitentComponent
        , OdabirAvansaComponent
        , OdabirDokumentaComponent     
        , RekapitulacijaDokumenataComponent
        , OdabirDokumentaV2Component
        , RekapitulacijaRacunaComponent   
        , FilterWithPovezanDokumentComponent
        , SpisakIskoriscenihComponent
        , SpisakPoreskihOslobodjenjaComponent
        , RekapitulacijaComponent
        , SendEdokumentComponent
        , FilterWithOrgJedComponent
        , EkranskaKarticaKomitenataComponent, VrstaStavkiKodKupcaComponent, VrstaStavkiKodKupcaUpdateComponent, VrstaStavkiKodKupcaModalUpdateComponent, FilterOnlyKomitentComponent, EkranskaKarticaKomitenataModalComponent, EkranskaKarticaKomitenataUpdateComponent,
            PoljaZaVelikeLanceComponent,
            OdabirAvansaV2Component,
            DefaultTableWithExpandComponent,
            GetPropertyValuePipe,
            RowColorDirective,
            PoljaZaVelikeLanceComponent, RowColorDirective, GabaritiRobeComponent, OdabirAvansaV2Component, DefaultTableWithExpandComponent, GetPropertyValuePipe 
            ,TransporteriComponent
        , IzvestajONenaplacenimRacunimaComponent
         , InstrukcijeZaPlacanjaComponent
      , PonoviComponent
      , FakDokumentUplataUpdateComponent
      , FakDokumentUplataModalUpdateComponent
      , KpoObrazacComponent
    ],

    exports:[
        VrstaStavkiUpdateComponent
        , FakDokumentTabsComponent
        , FakDokumentUpdateComponent
        , FakDokumentStavkaUpdateComponent
        , FakVrstaTroskaUpdateComponent
        , TrosakDokumentTabsComponent
        , TrosakDokumentUpdateComponent
        , TrosakDokumentStavkaUpdateComponent
        , RowColorDirective
        , FilterWithKomitentComponent
      , PonoviComponent
      , FakDokumentUplataUpdateComponent
    ],
    // entryComponents:[
    //     VrstaStavkiModalUpdateComponent
    //     , FakDokumentStavkaModalUpdateComponent
    //     , FakVrstaTroskaModalUpdateComponent
    //     , TrosakDokumentStavkaModalUpdateComponent
    //     , FilterWithKomitentComponent
    //     , DefaultFilter
    //     , OdabirAvansaComponent
    //     , OdabirDokumentaComponent
    //     , OdabirDokumentaV2Component
    //     , FilterWithPovezanDokumentComponent
    //     , SpisakIskoriscenihComponent
    //     , SpisakPoreskihOslobodjenjaComponent
    //     , FilterWithOrgJedComponent
    //     , PoljaZaVelikeLanceComponent
    //     , EkranskaKarticaKomitenataModalComponent
    //     , VrstaStavkiKodKupcaModalUpdateComponent 
    //     , FilterOnlyKomitentComponent
    //     , GabaritiRobeComponent
    //     , TransporteriComponent
    //     , InstrukcijeZaPlacanjaComponent
    //     , PonoviComponent
    // ],
    providers:[
        ModalContainerService,
        ModalService,
        FakDokumentService,
        
    ]
})

export class FakModule {}
